/**
 * TravellerUtils plugini
 * Tänne on koottu näppäriä apufunktioita joita voi tarvita siellä sun täällä
 * Funkkarit on tarjolla Vue instanssin kautta joka paikassa.
 */

import moment from 'moment-timezone'

/**
 * Tarkistaa että vastaus on OK muotoinen
 */
function check_ok_response(response) {
  try {
    if (response.data.errorCode === 0) {
      return true
    }
  } catch (error) {
    return false
  }
  return false
}

/**
 * Tarkistaa että vastaus on ok ja että se on lista-tyyppinen
 */
function check_response_isarray(response) {
  try {
    if (Array.isArray(response.data)) {
      return true
    }
  } catch (error) {
    return false
  }
  return false
}

/**
 * Tarkistaa että vastaus on ok ja se on objekti
 */
function check_response_isobject(response) {
  try {
    if (typeof response.data === 'object' && response.data !== null) {
      return true
    }
  } catch (error) {
    return false
  }
  return false
}

/**
 * Tarkistaa että vastaus on ok ja että sieltä tuli objekti jonka sisällä on
 * ennalta määritetyn niminen jäsen.
 */
function check_response_object_with_member(response, member) {
  try {
    if (check_response_isobject(response)) {
      return response.data.hasOwnProperty(member)
    }
    return false
  } catch (error) {
    return false
  }
}

function authTokenValid(token) {
  try {
    if(!token) {
      return false;
    }
    const parts = token.split('.')

    const tokenObject = JSON.parse(atob(parts[1])) // toisessa tokenin osassa on vanhenemisajat yms.
    const now = Date.now() / 1000

    if (tokenObject.exp <= now) {
      console.error('Authentication token has expired')
      return false
    }
    return true
  } catch (error) {
    console.error(error)
    return false
  }
}

function makeID(prefix) {
  if (prefix == null || prefix.length < 1) {
    prefix = 'ID-'
  }
  const number = Math.floor(Math.random() * 100000)
  return prefix + number
}

function alfaNumericCompare(a, b) {
  let ret = 0
  if (isNaN(a)) {
    if (isNaN(b)) ret = a.localeCompare(b)
    else ret = 1
  } else {
    if (isNaN(b)) return -1

    const num1 = parseInt(a)
    const num2 = parseInt(b)
    if (num1 > num2) return 1

    if (num1 < num2) return -1

    return 0
  }

  return ret
}

function optionSort(a, b) {

  const idA = a.id;
  const idB = b.id;

  if (!isNaN(idA) && !isNaN(idB)) {
  return parseFloat(idA) - parseFloat(idB);
   }

  if (!isNaN(idA)) {
  return -1; 
  
  } else if (!isNaN(idB)) {
  return 1; 
  }

  return idA.localeCompare(idB);

}

function dateFromRtDateTime(date, time) {
  const ts = new moment(date)
  const timePart = new moment(time, 'HH:mm')
  ts.hour(timePart.hour())
  ts.minute(timePart.minute())
  ts.second(timePart.second())

  return ts
}

export default {
  checkResponseObjectWithMemeber: check_response_object_with_member,
  checkResponseIsObject: check_response_isobject,
  checkResponseIsArray: check_response_isarray,
  checkResponseIsOk: check_ok_response,
  optionSort: optionSort,
  authTokenValid: authTokenValid,
  makeID: makeID,
  alfaNumericCompare: alfaNumericCompare,
  dateFromRtDateTime: dateFromRtDateTime,
}
